import { Button, Icon, TextField } from "@mui/material";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import theme from "../../styles/theme";
import { BasicDatePicker } from "./BasicDatePicker";
import Input from "../../components/Input";
import { SaveButton } from "../../components/PillarOverviewModify";

interface Props {
  startDate: any;
  endDate: any;
  setStartDate: any;
  setEndDate: any;
  email: any;
  setEmail: any;
  removeFilter: any;
  competency: string;
  setCompetency: any;
  filterClick: any;
  isFiltered: boolean;
}
export const FilterBar = (props: Props) => {
  const {
    competency,
    setCompetency,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    email,
    setEmail,
    removeFilter,
    filterClick,
    isFiltered,
  } = props;

  return (
    <FlexGrow
      // justify="between"
      style={{
        background: theme.color.blue50,
        borderRadius: "5px 5px 0px 0px",
        // boxShadow: "rgba(0, 70, 255, 0.07) 0px 2px 3px 3px ",
        borderTop: "1px solid #d8e8fe",
        borderLeft: "1px solid #d8e8fe",
        borderRight: "1px solid #d8e8fe",
        gap: 5,
        padding: "10px 20px",
        fontWeight: "normal",
        color: theme.color.blue900,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <FlexBox style={{ flexDirection: "column", alignItems: "start" }}>
        <div>From</div>
        <BasicDatePicker
          maxDate={endDate}
          date={startDate}
          setDate={setStartDate}
        />
      </FlexBox>
      <FlexBox style={{ flexDirection: "column", alignItems: "start" }}>
        <span>To</span>
        <BasicDatePicker
          minDate={startDate}
          maxDate={new Date()}
          date={endDate}
          setDate={setEndDate}
        />
      </FlexBox>
      <FlexBox style={{ flexDirection: "column", alignItems: "start" }}>
        <span>Competency</span>
        <Input
          style={{ width: 120 }}
          placeholder={"code/pillar"}
          isFullWidth
          maxLength={7}
          value={competency}
          onChange={(e: any) => setCompetency(e.target.value?.toUpperCase())}
        />
      </FlexBox>
      <FlexBox style={{ flexDirection: "column", alignItems: "start" }}>
        <span>Email</span>
        <Input
          style={{ width: 170 }}
          placeholder={"user email"}
          isFullWidth
          value={email}
          onChange={(e: any) => setEmail(e.target.value)}
        />
      </FlexBox>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <SaveButton
          disabled={!email&&!competency}
          className="reduce_opct_onhover"
          type="submit"
          style={{
            // border: "2px solid #64748B",
            // padding: "8px 40px",
            color: "white",
            minWidth: 170,
          }}
          onClick={() => filterClick(competency, email)}
        >
          <Icon fontSize="medium">filter_alt_icon</Icon>
          Filter{" "}
        </SaveButton>

        <Button
          className="reduce_opct_onhover"
          onClick={removeFilter}
          disabled={!isFiltered && !email && !competency}
          variant="text"
          color="error"
          style={{
            // border: "2px solid #64748B",
            // padding: "8px 40px",
            fontSize: "14px",
          }}
        >
          <Icon fontSize="medium">close_icon</Icon>
          Remove Filter{" "}
        </Button>
      </div>
    </FlexGrow>
  );
};
